<template>
  <Modal ref="infoModal" title="Alunos Faturados" @cancel="close">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <div class="table-container" v-else>
      <div class="table-header">
        <StatusLegend :statusOptions="statusLegendOptions" />
      </div>

      <Table
        :headers="['Status', 'Vencimento', 'Bloqueio', 'Processo', 'Valor a pagar', 'Valor original', 'Valor do desconto', 'Ações']">
        <tr v-for="fatura in faturas" :key="fatura.id">
          <td>
            <BadgeCircle v-if="fatura.id_status === 1" color="yellow" />
            <BadgeCircle v-else-if="fatura.id_status === 2" color="green" />
            <BadgeCircle v-else-if="fatura.id_status === 10" color="green2" />
            <BadgeCircle v-else-if="fatura.id_status === 3" color="red" />
            <BadgeCircle v-else-if="fatura.id_status === 5" color="blue" />
            <BadgeCircle v-else />
          </td>
          <td>{{ fatura.created_at, 'Financeiro' | DateBRFilter }}</td>
          <td>{{ fatura.data_bloqueio }}</td>
          <td>{{ fatura.tipo_fatura }}</td>
          <td>{{ fatura.valor }}</td>
          <td>{{ fatura.valor_servico }}</td>
          <td>{{ fatura.discount_value ? `R$ ${fatura.discount_value}` : `-` }}</td>
          <td>
            <div class="actions">
              <div>
                <IconButton @handle:click="() => openDiscountModal(fatura)" color="secondary" title="Dar Desconto"
                  :disabled="fatura.discount_value || fatura.id_status != 1">
                  <PercentOutline :size="19" />
                </IconButton>
              </div>
            </div>
          </td>
        </tr>
      </Table>
    </div>

    <Modal ref="discountModal" title="Desconto" @cancel="closeDiscount">
      <form class="discount-container" @submit.prevent="handleSubmit">
        <Input type="number" legend="Valor do desconto" @update:modelValue="$event => (this.discountValue = $event)"
          :modelValue="discountValue" :disabled="loading" />

        <Textarea legend="Motivo do desconto" @update:modelValue="$event => (this.justificativa = $event)"
          :modelValue="justificativa" :disabled="loading" />

        <Button type="submit" text="Dar desconto" color="primary" :disabled="loading">
        </Button>
      </form>
    </Modal>
  </Modal>
</template>

<script>
import utils from '../../../../services/utils'
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import StatusLegend from 'core/StatusLegend'
import Table from 'core/Table'
import BadgeCircle from 'core/BadgeCircle'
import IconButton from 'core/IconButton'
import Button from 'core/Button'
import Input from 'core/Input'
import Textarea from 'core/Textarea'
import PercentOutline from 'icons/PercentOutline'

export default {
  name: 'InfoFaturaModal',
  components: {
    Modal,
    LoadingSpinner,
    StatusLegend,
    Table,
    BadgeCircle,
    IconButton,
    Button,
    Input,
    Textarea,

    PercentOutline,
  },
  data() {
    return {
      utils: utils,
      schema: '',
      discountValue: '',
      justificativa: '',
      selectedFatura: '',
      statusLegendOptions: [
        { legend: 'Pago', color: 'green' },
        { legend: 'PAGO (BAIXA MANUAL)', color: 'green2' },
        { legend: 'Pendente', color: 'yellow' },
        { legend: 'Cancelado', color: 'red' },
        { legend: 'CNH Popular', color: 'blue' },
        { legend: 'Gratuidade' },
      ],
      faturas: [],
      loaded: false,
      loading: false,
    }
  },
  methods: {
    async open(aluno, schema) {
      this.schema = schema
      this.$refs.infoModal.open()

      await this.detalhes(aluno, schema)
    },
    close() {
      this.loaded = false
    },
    async detalhes(aluno, schema) {
      const data = {
        schema,
        cpf: aluno.cpf,
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/faturas`, data)
        .then(res => {
          this.faturas = res.body.faturas
        })
        .catch(err => {
          this.$toasted.show(err.body.mensangem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loaded = true
        })
    },
    openDiscountModal(fatura) {
      this.selectedFatura = fatura
      this.$refs.discountModal.open()
    },
    closeDiscount() {
      this.discountValue = ''
      this.justificativa = ''

      this.$refs.discountModal.close()
    },
    async handleSubmit() {
      if (!this.discountValue) {
        this.$toasted.show('Insira um valor valido para o desconto.', {
          position: 'top-right',
        })

        return
      }

      this.loading = true

      this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/desconto`, {
        faturaId: this.selectedFatura.id,
        faturaSchema: this.schema,
        discountValue: this.discountValue,
        reason: this.justificativa,
      })
        .then(response => {
          this.$toasted.show(response.body.mensagem, {
            position: 'top-right',
          })
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
          this.closeDiscount()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  width: 80vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-container {
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .actions {
    display: flex;
    align-items: center;

    div {
      padding: 0 0.5rem;
      display: flex;
      justify-content: center;

      &:not(:first-child) {
        border-left: 1px solid #ECECEC;
      }

      &:not(:last-child) {
        border-right: 1px solid #ECECEC;
      }
    }
  }
}

.discount-container {
  width: 50vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  button {
    justify-content: center;
  }
}
</style>